import React from 'react'
import Modal from '@components/Common/Modal'
import { ModalSearchClienteProps } from '@modules/viagem/interfaces/SearchClienteModal'
import TableDestinatario from '../Table'
import Button from '@components/Common/Button'

const ModalDestinatario: React.FC <ModalSearchClienteProps> = props => {

    return(

        <Modal
            {...props}
            title = "Buscar destinatário"
            width = "100%"
        >
            <TableDestinatario {...props} />
            <div className='ml-auto mt-4'>
                <Button
                    label="Fechar"
                    onClick={() => props.setOpen(false)}
                />
            </div>
        </Modal>

    )

}

export default ModalDestinatario